/*
 * @Author: tong.yu1@simceredx.com
 * @Date: 2022-12-16 13:13:47
 * @LastEditors: tong.yu1@simceredx.com
 * @LastEditTime: 2022-12-20 09:00:01
 * @FilePath: \git\simsysconfig\ssologin\src\utils\imgList.js
 * @Description: 图片合集，页面引用时只需导入util即可
 */
import logo from "../assets/images/logo.png";
import loginTit from "../assets/images/login-tit.png";
import err404Img from "../assets/images/404.png";
import simLogo from "../assets/images/simlogo.svg";
import app1Logo from "../assets/images/app1.svg";
import headBg from "../assets/images/head-bg.png";
import down from "../assets/images/down.png";
import userIcon from "../assets/images/user-icon.png";
import pwdIcon from "../assets/images/pwd-icon.png";
import pwdCloseIcon from "../assets/images/icon-pwd-close.png";
import pwdOpenIcon from "../assets/images/icon-pwd-open.png";

const imgList =  {
    logo,
    loginTit,
    err404Img,
    simLogo,
    app1Logo,
    headBg,
    down,
    userIcon,
    pwdIcon,
    pwdCloseIcon,
    pwdOpenIcon
}
export default imgList